import { StandardConfigurationProperty, StandardConfigurationTag, } from "@plansoft-configuration-renderer/configuration-api";
import { findConfigurationAttachments } from "./findConfigurationAttachments";
import { findConfigurationAttachmentsFromProperties } from "./findConfigurationAttachmentsFromProperties";
// prevent useMemo running multiple times because of default parameters
const EMPTY = {};
export function extractConfigurationInfo(properties = EMPTY, attachments = EMPTY) {
    const infoImages = findConfigurationAttachments(attachments, StandardConfigurationTag.InfoImage);
    const infoFiles = findConfigurationAttachments(attachments, StandardConfigurationTag.InfoFile);
    const infoImagesFromProperties = findConfigurationAttachmentsFromProperties(properties, StandardConfigurationProperty.InfoImage);
    const infoFilesFromProperties = findConfigurationAttachmentsFromProperties(properties, StandardConfigurationProperty.InfoFile);
    return {
        infoText: properties[StandardConfigurationProperty.InfoText],
        infoImages: ifEmpty(infoImages, infoImagesFromProperties),
        infoFiles: ifEmpty(infoFiles, infoFilesFromProperties),
    };
}
function ifEmpty(left, right) {
    return left.length === 0 ? right : left;
}
//# sourceMappingURL=extractConfigurationInfo.js.map